module.exports = __webpack_public_path__ + "static/media/temperature_low.10daa059.svg";